import { SET_AUTOCOMPLETE_PREQUERY } from '@data/constants/actionTypes/autoComplete';

/**
 * @param {Object} value - An object with page type keys - at minimum it should have a "default" key with an array of
 * products. See /prospectus/src/utils/pageTypes.js for valid page types.
 */
const setAutoCompletePreQuery = value => ({ type: SET_AUTOCOMPLETE_PREQUERY, value });

export { setAutoCompletePreQuery };
